import LifeIcon from './LifeIcon';

export default LifeIcon;
